import Utils from './utils';
import DICOMMediaRenderer from 'libs/dicom-media-renderer';
export default function(params) {
  var self = this;

  self.defaults = {};
  self.disabled = ko.observable(false);
  self.enabled = ko.observable(true);

  self.config = _.extend({}, self.defaults, params);

  // Map all properties to 'self'
  ko.mapping.fromJS(params, {}, self);

  self.isNative = ko.observable(false);
  self.previewdImage = ko.observable(false);

  self.show = function(image, event) {
    if(self.disabled()) return;

    if(!self.previewdImage()) {
      var $container = $('#js-video-' + self.id()),
        renderer = new DICOMMediaRenderer({ src: image.media_src.url(), $container: $container.parent(),  style: {'max-width': '100%', 'height': '500px' } });

      renderer.present();
      $container.remove(); // remove the video container
      self.previewdImage(true);
    }

    Utils.toggleRowVisibility(event);
  };

  return self;
}



